import React from "react";
import Page from "../templates/conserve/water/waterpage";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
